export enum PreferentialRightGroup
{
    Sarskild,
    Allman,
    Oprioriterad,
    Efterstalld
}